import React from "react";
import cn from "classnames";
import SearchIcon from "@mui/icons-material/Search";
import styles from "./SearchInput.module.sass";

const SearchInput = ({
  className,
  placeholder,
  value,
  onChange,
  onClear,
  size = "medium",
  ...props
}) => {
  return (
    <div
      className={cn(
        styles.root,
        styles[size],
        className
      )}
    >
      <div className={styles.iconWrap}>
        <SearchIcon className={styles.icon} fontSize="small" />
      </div>
      <div className={styles.separator} aria-hidden />
      <input
        type="text"
        className={styles.input}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        {...props}
      />
      {onClear && value && (
        <button
          type="button"
          className={styles.clearBtn}
          onClick={() => onClear()}
          aria-label="Clear search"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      )}
    </div>
  );
};

export default SearchInput;
